<template>
  <div class="slide" :class="{ active: isActive }" :style="'width: ' + 100 / this.$parent.totalSlides + '%;'" :ref="'slide_' + index">
    <div class="slide-inner" :class="{ container: !this.$parent.isFormData }">
      <slot> </slot>
      <div class="slide-footer" v-if="!this.$parent.isFormData && !this.$parent.disableFooter && !this.disableFooter">
        <button type="button" class="btn-primary" @click="onClick">
          <Localize :text="buttonLabel" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Localize from '@/components/Localize.vue'

export default {
  name: 'Slide',
  components: {
    Localize
  },
  props: {
    index: Number,
    sectionid: String,
    pageid: String,
    disableFooter: {
      type: Boolean,
      default: false
    },
    buttonCallback: {
      type: Function,
      default: function() {
        console.log('Button callback (default)')
        this.$parent.next()
      }
    },
    buttonLabel: {
      type: String,
      default: 'Continue'
    }
  },
  data: function() {
    return {}
  },
  computed: {
    isActive: function() {
      if (this.$parent.isFormData) {
        return this.$store.getters.getActivePageId === this.pageid
      }
      return this.$parent.slideNum == this.index
    }
  },
  methods: {
    onClick: function() {
      this.buttonCallback(this.$parent)
    }
  },
  created: function() {
    this.$root.$emit('slider:update')
  }
}
</script>

<style scoped lang="scss">
.slider-wrapper {
}
</style>
